import Model from "../../Model.js";
import MonthPeriod from "../MonthPeriod.js";

/**
 * This is used to render a single value summing up the result of a
 * forecast in the forecast archive. It holds the specification key
 * and period corresponding to the value.
 *
 * @param {SeriesSpecificationKey} key - Unique identifier of a series
 *   specification
 * @param {MonthPeriod} period - Month of the column the value has
 *   been calculated for
 * @param {float} [value] - Value of the key at the corresponding
 *   period
 */
export default class ForecastSummaryValue extends Model {
	constructor({ key, period, value }) {
		super(...arguments);

		this._key = key;
		this._period = period;
		this._value = value;
	}

	getValue() {
		return this._value;
	}

	getPeriod() {
		return this._period;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.key = this._key;
		properties.period = this._period;

		return properties;
	}

	static transformMaterializationData(data, context) {
		const { key, period } = data.key;
		data.key = key;
		data.period = MonthPeriod.materialize(period, context);
	}
}
